/**
 * ncc react移动端组件库
 * @author zhanghuag
 * @version 1.0 2019-4-13
 */
import DHeader from './Layout/Header/index'
import Footer from './Layout/Footer/index'

import Avoid from './Other/Avoid/index'
import DEmpty from './Other/Empty/index'
import DButton from './Other/Button/index'
import AddButton from './Other/AddButton/index'

import DTextarea from './Form/Textarea/index.js'
import ListBase from './Form/ListBase/index.js'
import ListAll from './Form/ListAll/index.js'
import BasicInput from './Form/BasicInput/index.js'
import DatePicker from './Form/DatePicker/index.js'
import PullDown from './Form/PullDown/index.js'
import BasicRefer from './Form/BasicRefer/index.js'

import ApprovalProcess from './Module/approval_process/main/index.js'


import HrModal from './Notice/Modal/index.js'
import HrToast from 'src/hrzz/public/mobile/components/Notice/Toast/index.js'
import HrNewToast from './Notice/NewToast'
import Alert from '../components/Alert'


export  {
    DHeader,
    Footer,

    Avoid,
    DEmpty,
    DButton,
    AddButton,

    DTextarea,
    ListBase,
    ListAll,
    BasicInput,
    BasicRefer,
    DatePicker,
    PullDown,

    HrModal,
    HrToast,
    HrNewToast,
    ApprovalProcess,
    Alert
}
